import { useRef, useState } from 'react'
import { Box } from '@mui/material'
import { BaseButtons, BaseCheckbox, BaseScatola, ICONE, BaseGridLayout } from '@lucan/base-ui'
import { DATICONDUCENTE_VERBALE_DECURTAZIONE } from 'configuration/datiConducente'
import LineaSeparatrice from 'components/ui/LineaSeparatrice'
import MessaggioEvidenziato from 'components/ui/MessaggioEvidenziato'
import Sezione from 'components/ui/Sezione'
import Testo from 'components/ui/Testo'
import IconeConducenteProprietario from 'components/ui/datiConducente/IconeConducenteProprietario'
import RiassuntoSituazioneDatiConducente from 'components/ui/datiConducente/RiassuntoSituazioneDatiConducente'
import useSchermoStretto from 'hook/useSchermoStretto'
import { CFG_SITUAZIONI_DATI_CONDUCENTE, SITUAZIONE_DATI_CONDUCENTE } from '../utilDatiConducente'

const CFG = DATICONDUCENTE_VERBALE_DECURTAZIONE

export default function DecurtazionePuntiSituazione(props) {
  const { val, txt, situazione, setSituazione, isAzienda } = props

  const [situazioneMostrata, setSituazioneMostrata] = useState(situazione)

  const situazioniAbilitate = Object.values(SITUAZIONE_DATI_CONDUCENTE)
    .filter(situa => isAzienda ? situa !== SITUAZIONE_DATI_CONDUCENTE.CASO_A : true)

  const spiegazioneRef = useRef()

  function mostraSpiegazione() {
    spiegazioneRef.current.scrollIntoView()
  }

  return (
    <>
      <Sezione
        titolo={val(CFG.SITUAZIONE_TITOLO)}
        sottotitolo={val(CFG.SITUAZIONE_SOTTOTITOLO)}
      >
        <BaseGridLayout vertical alignCenter sx={{ mt: 0 }}>
          <BaseGridLayout>
            {situazioniAbilitate.map(situa =>
              <ScatolettaRiassuntivaSituazione
                val={val} txt={txt}
                situazione={situa}
                isSituazioneMostrata={situazioneMostrata === situa}
                setSituazioneMostrata={setSituazioneMostrata}
                mostraSpiegazione={mostraSpiegazione}
                key={situa}
              />
            )}
          </BaseGridLayout>

          <div ref={spiegazioneRef}>
            {situazioneMostrata ? (
              <ScatolaSpiegazioneSituazione
                txt={txt}
                situazione={situazioneMostrata}
                isSituazioneScelta={situazione === situazioneMostrata}
                setSituazioneScelta={setSituazione}
                key={situazioneMostrata}
              />
            ) : (
              <BaseScatola outlined>
                <MessaggioEvidenziato error titolo={val(CFG.SITUAZIONE_AVVISO_TITOLO)}>
                  {txt(CFG.SITUAZIONE_AVVISO_DESCR)}
                </MessaggioEvidenziato>
              </BaseScatola>
            )}
          </div>
        </BaseGridLayout>
      </Sezione>

      <Testo sx={{ mt: 3 }}>{txt(CFG.SITUAZIONE_ISTRUZIONI_PER_PROCEDERE)}</Testo>
    </>
  )
}



function ScatolettaRiassuntivaSituazione(props) {
  const {
    val, txt, situazione,
    isSituazioneMostrata, setSituazioneMostrata,
    mostraSpiegazione,
  } = props

  const { cfgNome, cfgTitoloRiga1, cfgTitoloRiga2 } = CFG_SITUAZIONI_DATI_CONDUCENTE[situazione]

  const schermoStretto = useSchermoStretto()

  return (
    <BaseScatola
      outlined centraContenuto
      sx={{
        width: '18rem', fontSize: '1.25rem',
        ...(isSituazioneMostrata && { borderColor: 'warning.main', borderWidth: 4 })
      }}
    >
      {txt(cfgNome)}:
      <br />
      {txt(cfgTitoloRiga1)}
      <br />
      {txt(cfgTitoloRiga2)}

      <Box sx={{ my: 2 }}>
        <IconeConducenteProprietario situazione={situazione} />
      </Box>

      <BaseButtons.Custom
        testo={val(CFG.SITUAZIONE_LEGGI_DETTAGLI)}
        color='warning'
        iconaFine={isSituazioneMostrata ? ICONE.ESPANDI_MENO : ICONE.ESPANDI_PIU}
        onClick={() => {
          setSituazioneMostrata(isSituazioneMostrata ? '' : situazione)
          if (schermoStretto && !isSituazioneMostrata) mostraSpiegazione()
        }}
      />
    </BaseScatola>
  )
}



function ScatolaSpiegazioneSituazione(props) {
  const {
    txt, situazione,
    isSituazioneScelta, setSituazioneScelta,
  } = props

  const { cfgDescrLunga } = CFG_SITUAZIONI_DATI_CONDUCENTE[situazione]

  const [conferma, setConferma] = useState(isSituazioneScelta)

  return (
    <BaseScatola outlined>
      <RiassuntoSituazioneDatiConducente txt={txt} situazione={situazione} />

      <LineaSeparatrice />

      {situazione === SITUAZIONE_DATI_CONDUCENTE.CASO_B &&
        <Testo sx={{ color: 'error.dark' }}>
          {txt(CFG.SITUAZIONE_CASO_B_DESCR_SPESE)}
        </Testo>
      }
      <Testo>{txt(cfgDescrLunga)}</Testo>

      <Box sx={{ m: 2, mb: 0 }}>
        <BaseCheckbox
          label={txt(CFG.SITUAZIONE_CONFERMA_CASO)}
          value={conferma}
          onChange={e => {
            setConferma(e.target.value)
            setSituazioneScelta(e.target.value ? situazione : '')
          }}
        />
      </Box>
    </BaseScatola>
  )
}